import { Outlet } from "react-router-dom";

import { useHydrateAuth } from "@/auth/hooks";
import { useAuthStore } from "@/auth/store";
import { AppHeader } from "@/layouts/AppHeader";

/**
 * Wrapper-Layout, das den Auth-Refresh-Versuch beim Mount auslöst.
 *
 * Globale Header-Navigation wird nur für authentifizierte Sessions gerendert
 * (Login-Seite bleibt damit „nackt"). Children-Routen (Dashboard, …)
 * entscheiden anhand der Guards selbst, was sie rendern.
 */
export function AppLayout() {
  useHydrateAuth();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return (
    <div className="min-h-screen bg-background">
      {isAuthenticated && <AppHeader />}
      <Outlet />
    </div>
  );
}
